import { Component } from "react";
import "./CookieNotification.css";
import PropTypes from "prop-types";
//import CookiePolicyLink from "./../CookiePolicyLink/CookiePolicyLink";
import { strings } from "./../data/strings";
import Text from "./../../Text/Text";
import { COOKIE_POLICY_URL, getStringValue } from "./../../../services/util";
import Button from "./../../formElements/Button/Button";
import LegalLink from "./../LegalLink/LegalLink";
import { Trans } from "react-i18next";

const COOKIE_NOTIFIED_NAME = "cookie_notified";
/**
 * A modal window with a message that the webapp uses Cookies.
 */
export default class CookieNotification extends Component {
  constructor(props) {
    super(props);

    this.onContinue = this.onContinue.bind(this);
  }

  onContinue() {
    setCookieNotified();
    this.props.onContinue && this.props.onContinue();
  }

  render() {
    return (
      <div className="cookie-notification">
        <div className="cookie-notification-content">
          <Trans i18nKey={"Common.weUseCookie"}>
            <span>{getStringValue(strings, "notification_text")}</span>
            <LegalLink
              label={<Text strings={strings} strKey="cookie_policy" />}
              documentUrl={COOKIE_POLICY_URL}
            />
            .
          </Trans>
        </div>
        <div className="actions">
          <Button className="btn" onClick={this.onContinue}>
            <Text strings={strings} strKey="continue_btn" />
          </Button>
        </div>
      </div>
    );
  }
}

CookieNotification.propTypes = {
  /** A callback fired when user clicks on 'Continue' from Cookies notification modal window. */
  onContinue: PropTypes.func,
};

export function isCookieNotified() {
  const item = localStorage.getItem(COOKIE_NOTIFIED_NAME);
  return item !== undefined && item !== null;
}

export function setCookieNotified() {
  localStorage.setItem(COOKIE_NOTIFIED_NAME, "true");
}
